module.exports = __webpack_public_path__ + "static/media/mountain9.dc692c93.jpg";